var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-mml-xybox"},[_c('p',{staticStyle:{"padding":"0px","margin":"0px"}},[_c('pre',[_vm._v(_vm._s(_vm.msgContent()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }